export const styles = (theme) => ({
  textElementStyleLight: {
    base: {
      fontSize: 14,
      fontFamily: theme.typography.fontFamily,
      color: theme.colorPalette.green_75,
      fontWeight: 400,
      backgroundColor: theme.palette.common.white,
      '::placeholder': {
        fontSize: 14,
        color: theme.colorPalette.grey_10_op_38
      },
      padding: 10
    },
    // Once input is valid the element applies the `complete` variant; without an explicit color
    // here the text falls back to the browser default (renders blue). Keep it in brand green.
    complete: {
      color: theme.colorPalette.green_75
    },
    invalid: {
      color: theme.palette.error.main
    }
  },
  textElementStyleDark: {
    base: {
      fontSize: 14,
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.common.white,
      fontWeight: 400,
      backgroundColor: theme.colorPalette.white_op_15,
      '::placeholder': {
        fontSize: 14,
        color: theme.colorPalette.beige_50_op_75
      },
      padding: 10
    },
    complete: {
      color: theme.palette.common.white
    },
    invalid: {
      color: theme.palette.error.main
    }
  }
});
